export default {"src":"/_next/static/media/CAD.6e32c06d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};